import React from "react";
import styles from "./ServiceHome.module.css";
import { Link } from "react-router-dom";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";

const ServiceHome = (props) => {
  return (
    <div className={`${styles.box} user-select-none`}>
      <div className={styles.iconContainer}>
        <img src={props.icon} alt="" className={styles.img} />
      </div>
      <p className={styles.heading}>{props.heading}</p>
      <p className={styles.text}>{props.content}</p>
      {/* Added a new container */}
      <div className={styles.arrowContainer}>
        <Link to="#">
          <HiOutlineArrowNarrowRight
            className={styles.to}
            size="2rem"
            color="#af8d05"
          />
        </Link>
      </div>
    </div>
  );
};

export default ServiceHome;
